import { Observable } from 'rxjs/Observable';
import { ModuleData } from '@objects';
import { Http } from '@angular/http';
import { Injectable, Compiler } from '@angular/core';

import 'rxjs/add/operator/map';

// Necessário para os novos modulos
import * as AngularCore from '@angular/core';
import * as AngularCommon from '@angular/common';
import * as AngularRouter from '@angular/router';
import * as AngularForms from '@angular/forms';
import * as AngularCommonHttp from '@angular/common/http';
import * as BrowserAnimations from '@angular/platform-browser/animations';
import * as AngularMaterial from '@angular/material';

declare var SystemJS: any;

@Injectable()
export class ModuleService {
    source = `http://${window.location.host}/`;

    constructor(private compiler: Compiler, private http: Http) {
        console.log(compiler);
    }

    loadModules(): Observable<ModuleData[]> {
        return this.http.get("./assets/modules.json?v=" + new Date().getTime())
            .map(res => res.json());
    }

    loadModule(moduleInfo: ModuleData): Observable<any> {
        let url = moduleInfo.location;
        return this.http.get(url)
            .map(res => res.text())
            .map(source => {
                const exports = {}; // isso vai segurar as exportações do módulo
                const modules = {   // esta é a lista de módulos acessíveis por plugins
                    '@angular/core': AngularCore,
                    '@angular/common': AngularCommon,
                    '@angular/router': AngularRouter,
                    '@angular/forms': AngularForms,
                    '@angular/common/http': AngularCommonHttp,
                    '@angular/platform-browser/animations': BrowserAnimations,
                    '@angular/material': AngularMaterial
                };

                const require: any = (module) => modules[module];
                eval(source);

                this.compiler.compileModuleAndAllComponentsSync(exports[`${moduleInfo.moduleName}`])
                return exports;
            });
    }

    loadModuleSystemJS(moduleInfo: ModuleData): Promise<any> {
        let url = moduleInfo.location;
        SystemJS.set('@angular/core', SystemJS.newModule(AngularCore));
        SystemJS.set('@angular/common', SystemJS.newModule(AngularCommon));
        SystemJS.set('@angular/router', SystemJS.newModule(AngularRouter));
        SystemJS.set('@angular/forms', SystemJS.newModule(AngularForms));
        SystemJS.set('@angular/common/http', SystemJS.newModule(AngularCommonHttp));
        SystemJS.set('@angular/platform-browser/animations', SystemJS.newModule(BrowserAnimations));
        SystemJS.set('@angular/material', SystemJS.newModule(AngularMaterial));


        // agora, importe o novo módulo
        return SystemJS.import(`${url}`).then((module) => {
            console.log(module);
            return this.compiler.compileModuleAndAllComponentsAsync(module[`${moduleInfo.moduleName}`]).then(compiled => {
                console.log(compiled);
                return module;
            });
        });
    }
}